// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__m2w_Q","title":"ClientInsurance_title__1Lg_f","itemText":"ClientInsurance_itemText__3Jegf"};